import { render, staticRenderFns } from "./gravitationTable.vue?vue&type=template&id=51c44758&scoped=true&"
import script from "./gravitationTable.vue?vue&type=script&lang=js&"
export * from "./gravitationTable.vue?vue&type=script&lang=js&"
import style0 from "./gravitationTable.vue?vue&type=style&index=0&id=51c44758&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c44758",
  null
  
)

export default component.exports